/**
 * @memberof module:util
 * @function
 * @name convertToMetric
 * @description Convert Lcl or Air Shipments to metric units to be used on search bar page.
 *
 * @param {Object} lclAirShipment - lcl or Air Shipment obj to be converted to metric unit
 * @returns {Object}
 *
 * @example
 * console.log(convertToMetric({ quantity: 5, totalWeight: 6, weightUnit: "LB", totalVolume: 46, volumeUnit:"CFT" }));
 * // { quantity: 5, totalWeight: 2.72, weightUnit: "KG", totalVolume: 1.3, volumeUnit: "CBM" }
 */
export const convertToMetric = (lclAirShipment) => {
  let quantity = lclAirShipment.quantity;
  let totalWeight = lclAirShipment.totalWeight;
  let weightUnit = lclAirShipment.weightUnit;
  let totalVolume = lclAirShipment.totalVolume;
  let volumeUnit = lclAirShipment.volumeUnit;

  // convert weight to metric i.e. LB to KG
  if (weightUnit === 'LB' || weightUnit === 'LBS') {
    totalWeight = Number(parseFloat(totalWeight / 2.205).toFixed(2));
    weightUnit = 'KG';
  }
  // convert volume to metric i.e. CFT to CBM
  if (volumeUnit === 'CFT') {
    totalVolume = Number(parseFloat(totalVolume / 35.315).toFixed(2));
    volumeUnit = 'CBM';
  }

  let finalObj = {
    quantity,
    totalWeight,
    weightUnit,
    totalVolume,
    volumeUnit,
  };

  // console.log(finalObj);

  return finalObj;
};
